// Shared behaviour for the Try & Buy landing page sections.
// Guarded against re-initializing: this file is included via a separate
// <script> tag in every tab-* section, so it executes once per section
// rendered on the page. Without this guard, duplicate click handlers on
// the same buttons cause toggles to cancel each other out.
if (!window.__tabTryAndBuyInit) {
  window.__tabTryAndBuyInit = true;
  document.addEventListener('DOMContentLoaded', function () {
  // Scroll reveal — mirrors useScrollReveal from the React prototype.
  var revealEls = document.querySelectorAll('.tab-reveal');
  if (revealEls.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  }

  // FAQ accordion.
  document.querySelectorAll('.tab-faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.tab-faq-item');
      var isOpen = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.tab-faq-item').forEach(function (i) {
        i.classList.remove('is-open');
        var q = i.querySelector('.tab-faq-question');
        if (q) { q.setAttribute('aria-expanded', 'false'); q.querySelector('.tab-faq-toggle').textContent = '+'; }
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        btn.querySelector('.tab-faq-toggle').textContent = '−';
      }
    });
  });
  });
}
